(() => {
  'use strict';

  const root = window.Shopify?.routes?.root || '/';
  const cartUrl = `${root}cart.js`;
  const addUrl = `${root}cart/add.js`;
  const changeUrl = `${root}cart/change.js`;

  // Offre visuelle « 2 achetés = 1 offert » : aucune unité supplémentaire
  // n'est ajoutée au panier. Les anciennes lignes _offert sont supprimées afin
  // qu'elles ne puissent jamais apparaître au paiement.
  const syncBogo = async () => {
    if (window.__puffBogoBusy) return false;
    window.__puffBogoBusy = true;
    try {
      const cart = await fetch(cartUrl, { headers: { Accept: 'application/json' } }).then((response) => response.json());
      let changed = false;
      let eligible = false;
      for (const item of cart.items) {
        if (item.properties && item.properties._offert) {
          changed = true;
          await fetch(changeUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: item.key, quantity: 0 }) });
        } else if (item.quantity >= 2) {
          eligible = true;
        }
      }
      return eligible || changed;
    } catch (_) { return false; }
    finally { window.__puffBogoBusy = false; }
  };
  window.PuffBogoSync = syncBogo;

  const toast = (message, options = {}) => {
    const el = document.getElementById('ThemeToast');
    if (!el) return;
    el.textContent = message;
    if (options.actions) {
      const wrap = document.createElement('div');
      wrap.className = 'theme-toast__actions';
      options.actions.forEach((action) => {
        const link = document.createElement('a');
        link.href = action.url;
        link.textContent = action.label;
        link.className = action.className || '';
        wrap.appendChild(link);
      });
      el.appendChild(wrap);
    }
    el.classList.add('is-visible');
    window.clearTimeout(el._timer);
    el._timer = window.setTimeout(() => el.classList.remove('is-visible'), options.duration || 3200);
  };

  const setCartCount = (count) => {
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.classList.toggle('is-empty', count === 0);
      el.classList.remove('is-bumped');
      window.requestAnimationFrame(() => el.classList.add('is-bumped'));
      window.setTimeout(() => el.classList.remove('is-bumped'), 500);
    });
    document.querySelectorAll('[data-cart-link]').forEach((el) => {
      el.setAttribute('aria-label', `Panier, ${count} article${count !== 1 ? 's' : ''}`);
    });
  };

  const refreshCartCount = async () => {
    try {
      const cart = await fetch(cartUrl, { headers: { Accept: 'application/json' } }).then((response) => response.json());
      setCartCount(cart.item_count || 0);
    } catch (_) { /* The standard cart page remains available if this request fails. */ }
  };


  const setupQuantityControls = () => {
    document.querySelectorAll('[data-quantity-minus]').forEach((button) => button.addEventListener('click', () => {
      const input = button.parentElement.querySelector('[data-quantity-input]');
      input.value = Math.max(Number(input.min || 1), Number(input.value || 1) - 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }));
    document.querySelectorAll('[data-quantity-plus]').forEach((button) => button.addEventListener('click', () => {
      const input = button.parentElement.querySelector('[data-quantity-input]');
      input.value = Number(input.value || 1) + 1;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }));
  };

  const setupCartQuantityControls = () => {
    document.querySelectorAll('[data-cart-quantity-minus], [data-cart-quantity-plus]').forEach((button) => {
      button.addEventListener('click', async () => {
        const input = button.parentElement.querySelector('[data-cart-quantity-input]');
        const line = input?.dataset.line;
        if (!input || !line) return;
        const next = button.hasAttribute('data-cart-quantity-minus') ? Math.max(0, Number(input.value) - 1) : Number(input.value) + 1;
        input.value = next;
        try {
          await fetch(changeUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: Number(line), quantity: next }) });
          await syncBogo();
          window.location.reload();
        } catch (_) { toast('Impossible de mettre à jour le panier.'); }
      });
    });
  };

  const formatMoney = (cents) => {
    const currency = window.Shopify?.currency?.active || 'EUR';
    return new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', { style: 'currency', currency }).format(cents / 100);
  };

  const setupProductVariant = () => {
    const rootEl = document.querySelector('[data-product-root]');
    const dataEl = document.querySelector('[data-product-json]');
    const select = rootEl?.querySelector('[data-variant-select]');
    if (!rootEl || !dataEl || !select) return;
    let variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (_) { return; }
    select.addEventListener('change', () => {
      const variant = variants.find((item) => String(item.id) === select.value);
      if (!variant) return;
      const price = rootEl.querySelector('[data-product-price]');
      if (price) {
        price.innerHTML = `<div class="price${variant.compare_at_price > variant.price ? ' price--sale' : ''}"><span class="price__current">${formatMoney(variant.price)}</span>${variant.compare_at_price > variant.price ? `<s class="price__compare">${formatMoney(variant.compare_at_price)}</s>` : ''}</div>`;
      }
      const submit = rootEl.querySelector('[data-add-to-cart]');
      if (submit) {
        submit.disabled = !variant.available;
        const label = submit.querySelector('span');
        if (label) label.textContent = variant.available ? 'Ajouter au panier' : 'Épuisé';
      }
      if (variant.featured_media?.preview_image?.src) {
        const image = rootEl.querySelector('[data-main-product-image]');
        if (image) image.src = variant.featured_media.preview_image.src;
      }
    });
  };

  const closeFilters = () => {
    document.querySelector('[data-filter-panel]')?.classList.remove('is-open');
    document.body.classList.remove('filters-open');
  };

  document.addEventListener('DOMContentLoaded', () => {
    const header = document.querySelector('[data-site-header]');
    const updateHeader = () => header?.classList.toggle('is-scrolled', window.scrollY > 20);
    updateHeader();
    window.addEventListener('scroll', updateHeader, { passive: true });

    const searchDrawer = document.querySelector('[data-search-drawer]');
    document.querySelectorAll('[data-search-toggle]').forEach((button) => button.addEventListener('click', () => {
      const willOpen = searchDrawer.hidden;
      searchDrawer.hidden = !willOpen;
      button.setAttribute('aria-expanded', String(willOpen));
      if (willOpen) searchDrawer.querySelector('[data-search-input]')?.focus();
    }));
    document.querySelectorAll('[data-search-close]').forEach((button) => button.addEventListener('click', () => {
      searchDrawer.hidden = true;
      document.querySelector('[data-search-toggle]')?.setAttribute('aria-expanded', 'false');
    }));

    const mobileMenu = document.querySelector('[data-mobile-nav]');
    document.querySelectorAll('[data-menu-toggle]').forEach((button) => button.addEventListener('click', () => {
      mobileMenu.hidden = false;
      button.setAttribute('aria-expanded', 'true');
      document.body.classList.add('menu-open');
    }));
    document.querySelectorAll('[data-menu-close]').forEach((button) => button.addEventListener('click', () => {
      mobileMenu.hidden = true;
      document.querySelector('[data-menu-toggle]')?.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('menu-open');
    }));

    document.querySelectorAll('[data-filter-toggle]').forEach((button) => button.addEventListener('click', () => {
      document.querySelector('[data-filter-panel]')?.classList.add('is-open');
      document.body.classList.add('filters-open');
    }));
    document.querySelectorAll('[data-filter-close]').forEach((button) => button.addEventListener('click', closeFilters));
    document.querySelectorAll('[data-clear-filters]').forEach((button) => button.addEventListener('click', () => { window.location.assign(button.closest('form').action); }));
    document.querySelectorAll('[data-sort-select]').forEach((select) => select.addEventListener('change', () => document.getElementById(select.getAttribute('form'))?.submit()));

    document.querySelectorAll('[data-expandable-toggle]').forEach((button) => button.addEventListener('click', () => {
      const content = button.parentElement.querySelector('[data-expandable-content]');
      const expanded = content.classList.toggle('is-expanded');
      button.querySelector('span').textContent = expanded ? 'Lire moins' : 'Lire plus';
      button.querySelector('.icon')?.classList.toggle('is-rotated', expanded);
    }));

    document.querySelectorAll('[data-product-form]').forEach((form) => form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const submit = form.querySelector('[type="submit"]');
      if (submit) submit.disabled = true;
      try {
        const response = await fetch(addUrl, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
        if (!response.ok) throw new Error();
        const bogoApplied = await syncBogo();
        await refreshCartCount();
        if (window.PuffCartDrawer?.open) {
          window.PuffCartDrawer.open();
        } else {
          toast(bogoApplied ? 'Produit ajouté — offre 2 achetés = 1 offert activée dans le panier.' : 'Produit ajouté au panier.', {
            duration: 6500,
            actions: [
              { label: 'Voir le panier', url: `${root}cart`, className: 'theme-toast__btn--cart' }
            ]
          });
        }
      } catch (_) { toast('Impossible d’ajouter ce produit au panier.'); }
      finally { if (submit) submit.disabled = false; }
    }));

    document.querySelectorAll('[data-media-thumb]').forEach((thumb) => thumb.addEventListener('click', () => {
      const gallery = thumb.closest('[data-product-gallery]');
      const image = gallery?.querySelector('[data-main-product-image]');
      if (image) { image.src = thumb.dataset.mediaUrl; image.alt = thumb.dataset.mediaAlt || ''; }
      gallery?.querySelectorAll('[data-media-thumb]').forEach((el) => el.classList.remove('is-active'));
      thumb.classList.add('is-active');
    }));

    setupQuantityControls();
    setupCartQuantityControls();
    setupProductVariant();

    document.querySelector('[data-recover-toggle]')?.addEventListener('click', (event) => {
      event.preventDefault();
      document.querySelector('.recover-form')?.removeAttribute('hidden');
    });
    document.querySelector('[data-address-new]')?.addEventListener('click', () => document.querySelector('[data-address-new-form]')?.removeAttribute('hidden'));
    document.querySelectorAll('[data-address-edit]').forEach((button) => button.addEventListener('click', () => document.getElementById(`EditAddress_${button.dataset.addressEdit}`)?.removeAttribute('hidden')));
    document.querySelectorAll('[data-address-cancel]').forEach((button) => button.addEventListener('click', () => button.closest('.address-form-wrap')?.setAttribute('hidden', '')));
  });
})();

(() => {
  'use strict';

  const drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;

  const body = document.body;
  const routes = window.Shopify?.routes || {};
  const routeRoot = routes.root || '/';
  const cartUrl = `${routeRoot}cart.js`;
  const changeUrl = `${routeRoot}cart/change.js`;
  const addUrl = `${routeRoot}cart/add.js`;
  const freeShippingThreshold = 2499;
  const isCartPage = body.classList.contains('template-cart');
  const openFromCartRedirect = new URLSearchParams(window.location.search).get('puff_cart') === 'open';
  let lastTrigger = null;
  let closeTimer = null;
  let reservationTimer = null;

  if (isCartPage) {
    let returnUrl = `${window.location.origin}${routeRoot}`;
    try {
      const referrer = new URL(document.referrer);
      const cartPath = `${routeRoot.replace(/\/$/, '')}/cart`;
      if (referrer.origin === window.location.origin && referrer.pathname !== cartPath) {
        returnUrl = referrer.href;
      }
    } catch (_) {}
    const redirectUrl = new URL(returnUrl);
    redirectUrl.searchParams.set('puff_cart', 'open');
    window.location.replace(redirectUrl.toString());
    return;
  }

  const formatMoney = (cents) => {
    const currency = window.Shopify?.currency?.active || 'EUR';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', { style: 'currency', currency }).format((Number(cents) || 0) / 100);
    } catch (_) {
      return `${((Number(cents) || 0) / 100).toFixed(2).replace('.', ',')} €`;
    }
  };

  const escapeHtml = (value) => String(value ?? '').replace(/[&<>"']/g, (character) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
  }[character]));

  const getCart = () => fetch(cartUrl, { headers: { Accept: 'application/json' } }).then((response) => {
    if (!response.ok) throw new Error('Cart request failed');
    return response.json();
  });

  const request = (url, payload) => fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(payload)
  }).then((response) => {
    if (!response.ok) throw new Error('Cart request failed');
    return response.json();
  });

  const setStatus = (message) => {
    const status = drawer.querySelector('[data-drawer-status]');
    if (!status) return;
    status.textContent = message;
    status.classList.add('is-visible');
    window.clearTimeout(status._timer);
    status._timer = window.setTimeout(() => status.classList.remove('is-visible'), 2800);
  };

  const updateCount = (count) => {
    document.querySelectorAll('[data-cart-count]').forEach((element) => {
      element.textContent = count;
      element.classList.toggle('is-empty', count === 0);
    });
    document.querySelectorAll('[data-cart-link]').forEach((element) => {
      element.setAttribute('aria-label', `Panier, ${count} article${count !== 1 ? 's' : ''}`);
    });
  };

  const renderProperties = (item) => Object.entries(item.properties || {})
    .filter(([key, value]) => key !== '_offert' && value !== null && value !== '')
    .map(([key, value]) => `<p class="puff-cart-drawer__variant">${escapeHtml(key)} : ${escapeHtml(value)}</p>`)
    .join('');

  const giftIcon = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 12v9H4v-9M2 7h20v5H2zM12 22V7M12 7s-2.5-5-5.5-3S12 7 12 7Zm0 0s2.5-5 5.5-3S12 7 12 7Z"/></svg>';
  const quantityIcon = (type) => type === 'increase'
    ? '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>'
    : '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14"/></svg>';

  const renderLine = (item, index) => {
    const image = item.image
      ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.product_title)}" width="134" height="152" loading="${index > 1 ? 'lazy' : 'eager'}">`
      : '';
    const variant = item.variant_title ? `<p class="puff-cart-drawer__variant">${escapeHtml(item.variant_title)}</p>` : '';
    const original = item.original_line_price > item.final_line_price ? `<s>${formatMoney(item.original_line_price)}</s>` : '';
    const properties = renderProperties(item);
    const promotion = item.original_line_price > item.final_line_price ? '<p class="puff-cart-drawer__offer-label">Promotion appliquée</p>' : '';
    return `<article class="puff-cart-drawer__line" data-drawer-item data-drawer-key="${escapeHtml(item.key)}" style="animation-delay:${index * 55}ms">
      <a class="puff-cart-drawer__image" href="${escapeHtml(item.url || '#')}" aria-label="Voir ${escapeHtml(item.product_title)}">${image}</a>
      <div class="puff-cart-drawer__line-content">
        <p class="puff-cart-drawer__brand">WaveAddict</p>
        <a class="puff-cart-drawer__line-title" href="${escapeHtml(item.url || '#')}">${escapeHtml(item.product_title)}</a>
        ${variant}${properties}${promotion}
        <div class="puff-cart-drawer__line-actions">
          <div class="puff-cart-drawer__quantity" aria-label="Quantité pour ${escapeHtml(item.product_title)}">
            <button type="button" aria-label="Retirer une unité" data-drawer-quantity="decrease">${quantityIcon('decrease')}</button>
            <input type="number" min="1" step="1" inputmode="numeric" value="${Number(item.quantity) || 1}" data-drawer-quantity-input>
            <button type="button" aria-label="Ajouter une unité" data-drawer-quantity="increase">${quantityIcon('increase')}</button>
          </div>
          <button class="puff-cart-drawer__remove" type="button" data-drawer-remove>Retirer</button>
        </div>
      </div>
      <div class="puff-cart-drawer__line-price">${original}<strong>${formatMoney(item.final_line_price)}</strong><span>${formatMoney(item.final_price)} / unité</span></div>
    </article>`;
  };

  const renderGift = (item, index, giftQuantity, giftSavings) => {
    const image = item.image ? `<img src="${escapeHtml(item.image)}" alt="" width="134" height="152" loading="lazy">` : '';
    return `<article class="puff-cart-drawer__line puff-cart-drawer__line--gift" data-drawer-gift style="animation-delay:${index * 55}ms">
      <span class="puff-cart-drawer__image" aria-hidden="true">${image}</span>
      <div class="puff-cart-drawer__line-content">
        <p class="puff-cart-drawer__brand">WaveAddict</p>
        <span class="puff-cart-drawer__line-title">${escapeHtml(item.product_title)}</span>
        ${item.variant_title ? `<p class="puff-cart-drawer__variant">${escapeHtml(item.variant_title)}</p>` : ''}
        <p class="puff-cart-drawer__offer-label">${giftIcon}${giftQuantity} cadeau${giftQuantity > 1 ? 'x' : ''} débloqué${giftQuantity > 1 ? 's' : ''}</p>
      </div>
      <div class="puff-cart-drawer__line-price"><s>${formatMoney(giftSavings)}</s><strong>${formatMoney(0)}</strong><span>Offert</span></div>
    </article>`;
  };

  const renderShipping = (cart) => {
    const shipping = drawer.querySelector('[data-drawer-shipping]');
    const message = drawer.querySelector('[data-drawer-shipping-message]');
    const status = drawer.querySelector('[data-drawer-shipping-status]');
    const progressBar = drawer.querySelector('[data-drawer-shipping-progress]');
    const remaining = freeShippingThreshold - Number(cart.total_price || 0);
    const progress = Math.min(100, Math.max(0, Math.round((Number(cart.total_price || 0) / freeShippingThreshold) * 100)));
    if (remaining > 0) {
      message.innerHTML = `Plus que <strong>${formatMoney(remaining)}</strong> pour la livraison offerte.`;
      status.textContent = 'Encore un petit effort';
    } else {
      message.innerHTML = '<strong>La livraison vous est offerte.</strong> Votre commande est prête à partir.';
      status.textContent = 'Débloquée';
    }
    progressBar.style.width = `${progress}%`;
    shipping.classList.toggle('is-unlocked', remaining <= 0);
    shipping.querySelector('[role="progressbar"]')?.setAttribute('aria-valuenow', String(progress));
  };

  const renderDrawer = (cart) => {
    const loading = drawer.querySelector('[data-drawer-loading]');
    const empty = drawer.querySelector('[data-drawer-empty]');
    const filled = drawer.querySelector('[data-drawer-filled]');
    const lines = drawer.querySelector('[data-drawer-lines]');
    const bogo = drawer.querySelector('[data-drawer-bogo]');
    const itemCount = Number(cart.item_count || 0);
    updateCount(itemCount);
    loading.hidden = true;
    empty.hidden = itemCount !== 0;
    filled.hidden = itemCount === 0;
    if (!itemCount) return;

    const groups = {};
    const normalItems = [];
    cart.items.forEach((item) => {
      if (item.properties && item.properties._offert) return;
      normalItems.push(item);
      const groupKey = String(item.product_id || item.variant_id);
      if (!groups[groupKey]) groups[groupKey] = { quantity: 0, first: item };
      groups[groupKey].quantity += Number(item.quantity) || 0;
    });
    lines.innerHTML = normalItems.map(renderLine).join('');
    const giftGroups = Object.values(groups)
      .map((group) => ({ ...group, giftQuantity: Math.floor(group.quantity / 2) }))
      .filter((group) => group.giftQuantity > 0);
    const bogoSavings = giftGroups.reduce((total, group) => total + (group.giftQuantity * (Number(group.first.final_price) || 0)), 0);
    giftGroups.forEach((group, index) => {
      lines.insertAdjacentHTML('beforeend', renderGift(group.first, normalItems.length + index, group.giftQuantity, group.giftQuantity * (Number(group.first.final_price) || 0)));
    });
    const bogoMessage = drawer.querySelector('[data-drawer-bogo-message]');
    if (bogoMessage) {
      if (giftGroups.length > 0) {
        bogoMessage.textContent = 'Votre 3e article est inclus gratuitement dans votre sélection.';
      } else {
        const maxGroupQuantity = Object.values(groups).reduce((max, group) => Math.max(max, group.quantity), 0);
        const remaining = Math.max(1, 2 - maxGroupQuantity);
        bogoMessage.textContent = `Ajoutez encore ${remaining} article${remaining > 1 ? 's' : ''} pour débloquer votre cadeau.`;
      }
    }
    bogo.hidden = false;
    renderShipping(cart);
    drawer.querySelector('[data-drawer-subtotal]').textContent = formatMoney(cart.total_price);
    drawer.querySelector('[data-drawer-total]').textContent = formatMoney(cart.total_price);
    const actualSavings = Math.max(0, Number(cart.original_total_price || cart.total_price) - Number(cart.total_price || 0));
    const savings = actualSavings + bogoSavings;
    drawer.querySelector('[data-drawer-savings]').textContent = formatMoney(savings);
    drawer.querySelector('[data-drawer-savings-row]').hidden = savings <= 0;
  };

  const syncBogoAndRender = () => {
    const sync = window.PuffBogoSync ? window.PuffBogoSync() : Promise.resolve(false);
    return sync.then(() => getCart()).then(renderDrawer);
  };

  const open = (trigger) => {
    if (trigger) lastTrigger = trigger;
    window.clearTimeout(closeTimer);
    drawer.hidden = false;
    drawer.classList.remove('is-closing');
    body.classList.add('cart-drawer-open');
    document.querySelectorAll('[data-cart-link]').forEach((link) => link.setAttribute('aria-expanded', 'true'));
    window.requestAnimationFrame(() => drawer.classList.add('is-open'));
    const loading = drawer.querySelector('[data-drawer-loading]');
    loading.hidden = true;
    drawer.querySelector('[data-drawer-empty]').hidden = true;
    drawer.querySelector('[data-drawer-filled]').hidden = true;
    const refresh = window.PuffBogoSync ? syncBogoAndRender() : getCart().then(renderDrawer);
    refresh.catch(() => {
      loading.hidden = true;
      setStatus('Impossible d’actualiser le panier. Réessayez dans un instant.');
    });
    window.setTimeout(() => drawer.querySelector('[data-cart-drawer-close]')?.focus(), 120);
  };

  const close = () => {
    if (drawer.hidden) return;
    drawer.classList.remove('is-open');
    drawer.classList.add('is-closing');
    body.classList.remove('cart-drawer-open');
    document.querySelectorAll('[data-cart-link]').forEach((link) => link.setAttribute('aria-expanded', 'false'));
    closeTimer = window.setTimeout(() => {
      drawer.hidden = true;
      drawer.classList.remove('is-closing');
      lastTrigger?.focus();
    }, 430);
  };

  const changeLine = (card, quantity) => {
    if (!card || card.classList.contains('is-updating')) return;
    const key = card.dataset.drawerKey;
    if (!key) return;
    card.classList.add('is-updating');
    request(changeUrl, { id: key, quantity: Math.max(0, Number(quantity) || 0) })
      .then(() => syncBogoAndRender())
      .catch(() => {
        card.classList.remove('is-updating');
        setStatus('La mise à jour n’a pas pu être effectuée.');
      });
  };

  const startReservationTimer = () => {
    const minutes = drawer.querySelector('[data-drawer-minutes]');
    const seconds = drawer.querySelector('[data-drawer-seconds]');
    if (!minutes || !seconds || reservationTimer) return;
    const storageKey = 'puffaddict_reservation_ends_at';
    let endsAt;
    try { endsAt = Number(sessionStorage.getItem(storageKey)); } catch (_) {}
    if (!endsAt || endsAt <= Date.now()) {
      endsAt = Date.now() + (15 * 60 * 1000);
      try { sessionStorage.setItem(storageKey, String(endsAt)); } catch (_) {}
    }
    const tick = () => {
      const rest = Math.max(0, endsAt - Date.now());
      const totalSeconds = Math.ceil(rest / 1000);
      minutes.textContent = String(Math.floor(totalSeconds / 60)).padStart(2, '0');
      seconds.textContent = String(totalSeconds % 60).padStart(2, '0');
      if (rest <= 0) {
        endsAt = Date.now() + (15 * 60 * 1000);
        try { sessionStorage.setItem(storageKey, String(endsAt)); } catch (_) {}
      }
    };
    tick();
    reservationTimer = window.setInterval(tick, 1000);
  };

  drawer.addEventListener('click', (event) => {
    const closeButton = event.target.closest('[data-cart-drawer-close]');
    if (closeButton) { close(); return; }

    const quantityButton = event.target.closest('[data-drawer-quantity]');
    if (quantityButton) {
      const card = quantityButton.closest('[data-drawer-item]');
      const input = card?.querySelector('[data-drawer-quantity-input]');
      if (!input) return;
      const next = Math.max(0, Number(input.value || 1) + (quantityButton.dataset.drawerQuantity === 'increase' ? 1 : -1));
      if (next < 1) changeLine(card, 0);
      else { input.value = next; changeLine(card, next); }
      return;
    }

    const removeButton = event.target.closest('[data-drawer-remove]');
    if (removeButton) { changeLine(removeButton.closest('[data-drawer-item]'), 0); return; }

    const addButton = event.target.closest('[data-cart-add]');
    if (addButton && !addButton.disabled) {
      const variantId = addButton.dataset.variantId;
      if (!variantId) return;
      event.preventDefault();
      addButton.disabled = true;
      request(addUrl, { items: [{ id: Number(variantId), quantity: 1 }] })
        .then(() => syncBogoAndRender())
        .then(() => {
          addButton.classList.add('is-added');
          const label = addButton.querySelector('span');
          if (label) label.textContent = 'Ajouté';
          setStatus('Produit ajouté à votre panier.');
          window.setTimeout(() => {
            addButton.classList.remove('is-added');
            if (label) label.textContent = 'Ajouter';
          }, 1800);
        })
        .catch(() => setStatus('Impossible d’ajouter ce produit au panier.'))
        .finally(() => { addButton.disabled = false; });
    }
  });

  drawer.addEventListener('change', (event) => {
    const input = event.target.closest('[data-drawer-quantity-input]');
    if (!input) return;
    const amount = Math.max(1, Math.floor(Number(input.value) || 1));
    input.value = amount;
    changeLine(input.closest('[data-drawer-item]'), amount);
  });

  document.querySelectorAll('[data-cart-link]').forEach((link) => {
    link.setAttribute('aria-controls', 'PuffCartDrawer');
    link.setAttribute('aria-expanded', 'false');
    if (!isCartPage) {
      link.addEventListener('click', (event) => {
        event.preventDefault();
        open(link);
      });
    }
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && drawer.classList.contains('is-open')) close();
  });

  startReservationTimer();
  window.PuffCartDrawer = { open, close, refresh: () => getCart().then(renderDrawer) };
  if (openFromCartRedirect) {
    const cleanUrl = new URL(window.location.href);
    cleanUrl.searchParams.delete('puff_cart');
    window.history.replaceState({}, document.title, cleanUrl.toString());
    window.setTimeout(() => open(), 0);
  }
})();
